
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiConfigService } from './api-config.service';
import { FirebaseApp } from '@angular/fire/app';
import { Analytics, logEvent, setUserProperties } from '@angular/fire/analytics';
import { UserProfileService } from './user-profile.service';

@Injectable({
  providedIn: 'root'
})
export class CountrySelectionService {
  private countries = [
    { name: 'Botswana', code: 'BWA', id: 309 },
    { name: 'Namibia', code: 'NAM', id: 310 },
    { name: 'Zambia', code: 'ZMB', id: 307 },
    { name: 'Lesotho', code: 'LSO', id: 308 },
    { name: 'Eswatini', code: 'SWZ', id: 333 },
    { name: 'Malawi', code: 'MWI', id: 332 },
    { name: 'Zimbabwe', code: 'ZWE', id: 306 },
    { name: 'Other', code: 'BWA', id: 309 }
  ];

  private selectedCountry = new BehaviorSubject<any>(this.countries[0]);
  selectedCountry$ = this.selectedCountry.asObservable();

  constructor(private analytics: Analytics, private apiConfigService: ApiConfigService, private userProfileService: UserProfileService) {
    const savedProfile = this.userProfileService.getProfileData();
    let initialCountry = this.countries[0]; // Default to Botswana

    if (savedProfile && savedProfile.countryOffice) {
      const savedCountry = this.countries.find(c => c.id === savedProfile.countryOffice.id);
      if (savedCountry) {
        initialCountry = savedCountry;
      }
    }

    this.selectedCountry.next(initialCountry);

    // Set user properties and log the initial country selection event to Firebase
    logEvent(this.analytics, 'country_selection', {
      country_name: initialCountry.name,
      country_code: initialCountry.code,
    });
    setUserProperties(this.analytics, {
      country: initialCountry.name,
    });
  }

  getCountries() {
    return this.countries.slice().sort((a, b) => a.name.localeCompare(b.name));
  }

  setSelectedCountry(country: any) {
    this.selectedCountry.next(country);
    logEvent(this.analytics, 'country_selection', {
      country_name: country.name,
      country_code: country.code,
    });
    setUserProperties(this.analytics, {
      country: country.name,
    });
  }

  getSelectedCountry(): any {
    return this.selectedCountry.getValue();
  }

  getApiUrl(service: string, country: any): string {
    return this.apiConfigService.getApiUrl(service, country.code, country.id);
  }
}
